<template>
  <div>
    <div
      class="support-btn"
      ref="toolIcon"
      @click="openSupportTool"
      v-drag="greet"
    >
      <img
        style="width: 32px"
        src="@/assets/img/meterSelection/support@2x.png"
      />辅助工具
    </div>
    <SupportTool :dialogVisible.sync="toolDialog" />
  </div>
</template>
<script>
import { isElementInViewport } from '@/utils'
import SupportTool from './supportTool.vue'
export default {
  name: 'support-tool-icon',
  components: { SupportTool },
  data () {
    return {
      toolDialog: false // 辅助工具弹窗
    }
  },
  directives: {
    drag: {
      // 指令的定义
      bind: function (a, binding) {
        let isStart = false // 是否已经开始拖拽
        let distance = {} // 拖动的距离
        let l, t // 当前被拖动的距离
        let w // 当前屏幕宽度
        let h // 当前屏幕的高度

        // 判断点击对象是不是在父容器中
        function isParent (obj, parentObj) {
          while (
            obj !== undefined &&
            obj != null &&
            obj.tagName &&
            obj.tagName.toUpperCase() !== 'BODY'
          ) {
            if (obj === parentObj) {
              return true
            }
            obj = obj.parentNode
          }
          return false
        }
        a.onmousedown = function (e) {
          e.preventDefault()

          a.style.transition = 'none'
          // a.style.width = '125px'

          w = document.documentElement.clientWidth || document.body.clientWidth // 当前屏幕宽度
          h =
            document.documentElement.clientHeight || document.body.clientHeight // 当前屏幕的高度
          if (isStart) return // 如果已经开始拖拽， 返回
          isStart = true // 如果没有开始拖拽， 则可以拖拽
          const { clientX, clientY } = e
          const x = clientX - a.offsetLeft
          const y = clientY - a.offsetTop

          document.onmousemove = function (e) {
            e.preventDefault()
            l = e.clientX - x
            t = e.clientY - y

            a.style.transition = 'none'

            if (l < 0 && t < 0) {
              a.style.left = 0 + 'px'
              a.style.top = 0 + 'px'
            } else if (l < 0 && t + a.clientHeight < h) {
              a.style.left = 0 + 'px'
              a.style.top = t + 'px'
            } else if (l < 0 && t + a.clientHeight >= h) {
              a.style.left = 0 + 'px'
              a.style.top = h - a.clientHeight + 'px'
            } else if (l + a.clientWidth > w && t < 0) {
              a.style.left = w - a.clientWidth + 'px'
              a.style.top = 0 + 'px'
            } else if (l + a.clientWidth < w && t + a.clientHeight >= h) {
              a.style.left = l + 'px'
              a.style.top = h - a.clientHeight + 'px'
            } else if (l + a.clientWidth < w && t < 0) {
              a.style.left = l + 'px'
              a.style.top = 0 + 'px'
            } else if (l + a.clientWidth > w && t + a.clientHeight < h) {
              a.style.left = w - a.clientWidth + 'px'
              a.style.top = t + 'px'
            } else if (l + a.clientWidth > w && t + a.clientHeight >= h) {
              a.style.left = w - a.clientWidth + 'px'
              a.style.top = h - a.clientHeight + 'px'
            } else {
              a.style.left = l + 'px'
              a.style.top = t + 'px'
            }
          }

          document.onmouseup = function (e) {
            if (!isParent(e.target, a)) {
              return
            }

            // 判断是左吸附还是右吸附
            if (e.clientX >= w / 2) {
              // 右吸附
              // a.style.left = ''
              // 边界判断
              if (w - e.clientX + x - a.clientWidth > w - a.clientWidth) {
                // a.style.right = w - a.clientWidth + 'px'
              } else if (w - e.clientX + x - a.clientWidth < 0) {
                // a.style.right = '0px'
              } else {
                // a.style.right = w - e.clientX + x - a.clientWidth + 'px'
              }

              // 延时动画
              setTimeout(() => {
                a.style.transition = 'all 0.3s ease-in-out'
                // a.style.right = '0px'
                // a.style.width = ''
              }, 300)
            } else {
              // 左吸附
              a.style.transition = 'all 0.3s ease-in-out'
              // a.style.left = '0px'
              // a.style.right = '0px'
              // a.style.width = ''
            }

            // 清除事件
            document.onmouseup = null
            document.onmousemove = null
            isStart = false
            distance = {
              type: 'move',
              clientX: clientX - e.clientX, // 拖动的 x 距离
              clientY: clientY - e.clientY // 拖动的 y 距离
            }

            binding.value(distance) // 返回拖动的距离
          }
        }
      }
    }
  },
  methods: {
    openSupportTool () {
      if (!this.canClick) return
      this.$refs.toolIcon.style.transition = 'all 0.3s ease-in-out'
      this.toolDialog = true
    },
    // 拖拽回调
    greet (val) {
      if (val.clientX === 0 && val.clientY === 0) {
        this.canClick = true
      } else {
        this.canClick = false
      }
    },
    recordPosition () {
      const obj = {
        left: (this.$refs.toolIcon && this.$refs.toolIcon.style.left) || '84vw',
        top: (this.$refs.toolIcon && this.$refs.toolIcon.style.top) || '170px'
      }
      sessionStorage.setItem('supportTool', JSON.stringify(obj))
    }
  },
  mounted () {
    const supportTool = sessionStorage.getItem('supportTool')
    if (supportTool) {
      const obj = JSON.parse(supportTool)
      this.$refs.toolIcon.style.left = obj.left
      this.$refs.toolIcon.style.top = obj.top
    }

    const isVisible = isElementInViewport(this.$refs.toolIcon)
    if (!isVisible) {
      this.$refs.toolIcon.style.left = '84vw'
      this.$refs.toolIcon.style.top = '170px'
    }
  },
  created () {
    // 页面丢失前记录视频播放结束时间
    window.addEventListener('beforeunload', this.recordPosition)
  },
  beforeDestroy () {
    this.recordPosition()

    window.removeEventListener('beforeunload', this.recordPosition)
  }
}
</script>
<style lang="scss" scoped>
.support-btn {
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #2a54d1;
  position: fixed;
  z-index: 1024;
  left: 84vw;
  top: 170px;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 4px;
  user-select: none;
}
</style>
